import React from 'react';
import { withStyles, makeStyles } from '@material-ui/styles';
import { Link as RouterLink } from 'react-router-dom';
//import ScheduleIcon from '@material-ui/icons/Schedule';
import PeopleIcon from '@material-ui/icons/People';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import WarningIcon from '@material-ui/icons/Warning';
import ClearIcon from '@material-ui/icons/Clear';
import SendIcon from '@material-ui/icons/Send';
import AvTimerIcon from '@material-ui/icons/AvTimer';
import DateRangeIcon from '@material-ui/icons/DateRange';
import EventIcon from '@material-ui/icons/Event';
import GetAppIcon from '@material-ui/icons/GetApp';
import {
    Grid,
    Paper,
    Table,
    TableBody,
    TableContainer,
    TableRow,
    TableHead,
    TableCell,
    ListItemText,
    TextField,
    InputAdornment,
    Checkbox,
    Typography,
    Link,
    Breadcrumbs,
    Divider,
    Button,
    FormLabel,
    IconButton,
    Step,
    Stepper,
    StepContent,
    StepLabel,
    StepConnector,
    CircularProgress
    //FormGroup,
    //FormControl,
    //FormControlLabel
} from '@material-ui/core';

import {
    Alert,
    Pagination,
    EnhancedCheckbox,
    Month,
    Year,
    Periodicity,
    Preview
} from './components';
import env from 'common/env';
import { markets } from './http';

const styles = theme => ({
    pageInner: {
        maxWidth: 1200,
        margin: '0 auto'
    },
    breadcrumbRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2)
    },
    backButton: {
        backgroundColor: '#fff',
        boxShadow: '0 1px 2px rgba(16, 24, 40, 0.08)',
        '&:hover': {
            backgroundColor: '#fff'
        }
    },
    breadcrumbLink: {
        color: '#6B7280',
        fontWeight: 500,
        '&:hover': {
            color: '#3f51b5'
        }
    },
    breadcrumbCurrent: {
        color: '#111827',
        fontWeight: 600
    },
    pageHeader: {
        marginBottom: theme.spacing(3)
    },
    pageTitle: {
        fontWeight: 700,
        letterSpacing: '-0.02em',
        color: '#111827'
    },
    pageSubtitle: {
        color: '#6B7280',
        marginTop: theme.spacing(0.5)
    },
    paper: {
        borderRadius: 16,
        boxShadow: '0 1px 3px rgba(16, 24, 40, 0.06), 0 1px 2px rgba(16, 24, 40, 0.04)',
        padding: theme.spacing(4)
    },
    '@global': {
        '.MuiOutlinedInput-root': {
            borderRadius: 10,
            backgroundColor: '#FAFAFB'
        }
    },
    stepContent: {
        paddingLeft: theme.spacing(5),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2)
    },
    stepTitle: {
        fontWeight: 700,
        fontSize: '1.05rem',
        color: '#111827'
    },
    stepper: {
        paddingLeft: theme.spacing(5)
    },
    tableWrapper: {
        borderRadius: 12,
        border: '1px solid #E5E7EB',
        overflow: 'hidden'
    },
    actionButton: {
        borderRadius: 10,
        textTransform: 'none',
        fontWeight: 600,
        boxShadow: 'none',
        padding: theme.spacing(1, 3)
    },
    warningBadge: {
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
        minWidth: 'fit-content',
        padding: '4px 8px',
        boxShadow: 'none'
    }
});

const ColorlibConnector = withStyles({
    alternativeLabel: {
        left: 10
    },
    lineVertical: {
        borderColor: '#E5E7EB',
        borderLeftWidth: 2
    }
})(StepConnector);

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: 'rgba(63, 81, 181, 0.02)'
        }
    }
}))(TableRow);

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: 'rgba(63, 81, 181, 0.08)',
        color: '#3f51b5',
        fontWeight: 600,
        borderBottom: 'none'
    }
}))(TableCell);

const columns = [
    {
        id: 'raisonSociale',
        label: 'Raison sociale',
        minWidth: '60%',
        align: 'left'
    },
    {
        id: 'market',
        label: 'Marché(s)',
        minWidth: '40%',
        align: 'left'
    }
];

const useColorlibStepIconStyles = makeStyles({
    root: {
        position: 'relative',
        right: 10,
        backgroundColor: '#3f51b5',
        zIndex: 1,
        color: '#fff',
        width: 44,
        height: 44,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0 2px 6px rgba(63, 81, 181, 0.3)'
    }
});

function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { icon } = props;

    const icons = {
        1: <DateRangeIcon />,
        2: <EventIcon />,
        3: <AvTimerIcon />,
        4: <PeopleIcon />,
        5: <GetAppIcon />,
        6: <SendIcon />
    };

    return <div className={classes.root}>{icons[String(icon)]}</div>;
}

// Replaces the plain "select all / select market" buttons with a segmented
// chip that visually highlights when active, matching the rest of the app.
const useChipStyles = makeStyles(() => ({
    chip: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: 999,
        border: '1px solid #E5E7EB',
        backgroundColor: '#fff',
        padding: '4px 16px 4px 8px',
        textTransform: 'none',
        fontWeight: 500,
        color: '#4B5563',
        transition: 'all 0.15s ease',
        '&:hover': {
            backgroundColor: '#fff',
            borderColor: '#3f51b5'
        }
    },
    chipActive: {
        borderColor: '#3f51b5',
        backgroundColor: 'rgba(63, 81, 181, 0.08)',
        color: '#3f51b5',
        fontWeight: 600
    }
}));

const SelectionChip = ({ label, checked, indeterminate, disabled, onClick }) => {
    const classes = useChipStyles();
    return (
        <Button
            onClick={onClick}
            disabled={disabled}
            className={`${classes.chip} ${checked ? classes.chipActive : ''}`}
            startIcon={
                <Checkbox
                    size="small"
                    color="primary"
                    checked={checked}
                    indeterminate={indeterminate}
                    disabled={disabled}
                    style={{ padding: 4 }}
                />
            }>
            {label}
        </Button>
    );
};

class GenerateBills extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props,
            list: [],
            listOfMerchantSelected: [],
            listOfMerchantSelectedUpdated: false,
            all: false,
            init: true,
            dateHasChanged: false,
            isGenerating: false,
            numberOfSelected: 0,
            anchorAlert: null,
            assuranceExpiree: '0',
            assuranceManquante: '0',
            bapRetard: '0',
            bloque: '0',
            siret: '',
            searchValue: '',
            page: 1,
            numberOfPages: 0,
            total: 0,

            years: '',
            frequency: 1,
            weeksPerYear: 1,
            selectedMonths: [],
            previewHasToUpdate: false,
            isSending: false,
            listOfBillsCreated: [],
            isDone: false,
            disableWeeksPerYear: true,
            attendance: false,
            markets: [],
            selectedMarkets: []
        };
    }

    componentDidUpdate = (prevProps, prevState) => {
        (prevState.page != this.state.page ||
            prevState.searchValue != this.state.searchValue ||
            this.state.listOfMerchantSelectedUpdated ||
            prevState.all != this.state.all) &&
            this.getData();

        this.state.isGenerating && this.generateBills();
        this.state.isSending && this.sendBills();

        if (
            this.state.selectedMonths != prevState.selectedMonths ||
            this.state.years != prevState.years
        ) {
            this.calculateWeeksPerMonths();
        }

        if (
            this.state.previewHasToUpdate &&
            prevState.previewHasToUpdate != this.state.previewHasToUpdate
        ) {
            this.setState({
                previewHasToUpdate: false
            });
        }

        if (
            this.state.listOfMerchantSelectedUpdated &&
            prevState.listOfMerchantSelectedUpdated != this.state.listOfMerchantSelectedUpdated
        ) {
            this.setState({
                previewHasToUpdate: true
            });
        }
    };

    componentDidMount = () => {
        this.getMarkets();
        this.getData();
    };

    getData = () => {
        const {
            page,
            searchValue,
            listOfMerchantSelected,
            all,
            init,
            selectedMarkets
        } = this.state;

        const formData = new FormData();

        formData.append('page', page);
        formData.append('search', searchValue);
        formData.append('all', all);
        formData.append('init', init);
        formData.append('selectedMarkets', JSON.stringify(selectedMarkets));

        listOfMerchantSelected.map((merchantId, index) => {
            formData.append(`listOfSelected[${index}]`, merchantId);
        });

        fetch(`${env}/regie/get-list-of-subscribers`, {
            method: 'POST',
            body: formData
        })
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                this.setState({
                    ...data,
                    listOfMerchantSelectedUpdated: false,
                    init: false
                });
            })
            .catch(
                error => {
                    console.error(error);
                    alert('Echec de la récupération des données');
                } // Handle the error response object
            );
    };

    calculateWeeksPerMonths = () => {
        const { years, selectedMonths, frequency } = this.state;

        const formData = new FormData();
        formData.append('year', years);
        formData.append('months', JSON.stringify(selectedMonths));
        formData.append('frequency', frequency);

        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/regie/calculate-weeks-per-months`,
            {
                method: 'POST',
                body: formData
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                this.setState({
                    ...data,
                    previewHasToUpdate: true
                });
            })
            .catch(
                error => {
                    console.error(error);
                    alert('Echec de la récupération des données');
                } // Handle the error response object
            );
    };

    getBack = () => {
        const { history } = this.props;
        history.goBack();
    };

    handleAlert = (
        event = null,
        assuranceExpiree = '0',
        assuranceManquante = '0',
        bapRetard = '0',
        bloque = '0',
        siret
    ) => {
        this.setState({
            anchorAlert: event ? event.currentTarget : null,
            assuranceExpiree: assuranceExpiree,
            assuranceManquante: assuranceManquante,
            bapRetard: bapRetard,
            bloque: bloque,
            siret: siret
        });
    };

    alertMerchant = merchant => {
        let alert = 0;
        merchant.assuranceExpiree != '0' && ++alert;
        merchant.assuranceManquante == '1' && ++alert;
        merchant.bapRetard != '0' && ++alert;
        merchant.bloque != '0' && ++alert;

        return (
            <Grid spacing={1} container direction="row" justify="flex-start" alignItems="center">
                {alert > 0 && (
                    <Grid item>
                        <Button
                            onClick={event =>
                                this.handleAlert(
                                    event,
                                    merchant.assuranceExpiree,
                                    merchant.assuranceManquante,
                                    merchant.bapRetard,
                                    merchant.bloque,
                                    merchant.siret
                                )
                            }
                            size="small"
                            variant="contained"
                            color="primary"
                            className={this.props.classes.warningBadge}
                            style={{
                                background: '#EF4444'
                            }}>
                            <WarningIcon fontSize="small" />{' '}
                            <Typography style={{ color: 'white', marginLeft: 5, fontWeight: 500 }}>
                                {alert}
                            </Typography>
                        </Button>
                    </Grid>
                )}
                <Grid item>
                    <ListItemText primary={merchant.raisonSociale} />
                </Grid>
            </Grid>
        );
    };

    handleSearch = ({ target: { value } }) => {
        this.setState({
            searchValue: value,
            page: 1
        });
    };

    clearSearch = () => {
        this.setState({
            searchValue: '',
            page: 1
        });
    };

    handlePagination = selectedPage => {
        this.setState({
            page: selectedPage
        });
    };

    handleAll = checked => {
        this.setState(prevState => ({
            all: checked,
            listOfMerchantSelectedUpdated: checked,
            listOfMerchantSelected: checked ? prevState.listOfMerchantSelected : [],
            selectedMarkets: []
        }));
    };

    handleListOfMerchant = (merchantId, withoutUpdate) => {
        const { listOfMerchantSelected } = this.state;

        const merchants = [...listOfMerchantSelected];
        const index = merchants.indexOf(merchantId);

        if (index > -1) {
            merchants.splice(index, 1);

            this.setState({
                all: false
            });
        } else {
            merchants.push(merchantId);
        }

        if (!withoutUpdate) {
            this.setState({
                listOfMerchantSelected: merchants,
                listOfMerchantSelectedUpdated: true
            });
        } else {
            this.setState({
                listOfMerchantSelected: merchants,
                previewHasToUpdate: true
            });
        }
    };

    prepareBillsForSending = (attendance = false) => {
        this.setState({
            isSending: true,
            attendance
        });
    };

    prepareBills = () => {
        const { selectedMonths, listOfMerchantSelected, years } = this.state;

        if (years == '') {
            alert('Veuillez sélectionner une année.');
            return;
        }

        if (selectedMonths.length == 0) {
            alert('Veuillez sélectionner au moins un mois.');
            return;
        }

        if (listOfMerchantSelected.length == 0) {
            alert('Veuillez sélectionner au moins un abonné.');
            return;
        }

        this.setState({
            isGenerating: true
        });
    };

    sendBills = () => {
        const { listOfBillsCreated, attendance } = this.state;

        const formData = new FormData();
        formData.append('bills', JSON.stringify(listOfBillsCreated));
        formData.append('attendance', attendance);

        fetch(`${env}/regie/new-send-subscriber-bills`, {
            method: 'POST',
            body: formData
        })
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                alert(data.message);

                this.setState({
                    isSending: false
                });
            })
            .catch(
                error => {
                    this.setState({
                        isSending: false
                    });
                    console.error(error);
                    alert('Echec de la récupération des données');
                } // Handle the error response object
            );
    };

    generateBills = () => {
        const {
            selectedMonths,
            listOfMerchantSelected,
            years,
            weeksPerYear,
            selectedMarkets
        } = this.state;

        const formData = new FormData();
        formData.append('year', years);
        formData.append('months', JSON.stringify(selectedMonths));
        formData.append('merchants', JSON.stringify(listOfMerchantSelected));
        formData.append('weeksPerYear', weeksPerYear);
        formData.append('markets', JSON.stringify(selectedMarkets));

        fetch(`${env}/regie/generate-subscriber-bills`, {
            method: 'POST',
            body: formData
        })
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                this.setState({
                    ...data,
                    isGenerating: false
                });
                alert(data.message);

                /*if (data.records.success > 0) {
                    const _confirm = window.confirm(
                        'Souhaitez vous envoyer les ' +
                            data.records.success +
                            ' factures par mail ? '
                    );
                    if (_confirm) {
                        this.setState({
                            isSending: true
                        });
                    }
                }*/
            })
            .catch(
                error => {
                    this.setState({
                        isGenerating: false
                    });
                    console.error(error);
                    alert('Echec de la récupération des données');
                } // Handle the error response object
            );
    };

    handleWeeks = ({ target: { value } }) => {
        this.setState({
            weeksPerYear: value
        });
    };

    handleSelectedMonths = value => {
        this.setState({
            selectedMonths: value
        });
    };

    handleYears = value => {
        this.setState({
            years: value
        });
    };

    handlePeriodicity = value => {
        this.setState({
            frequency: value
        });
    };

    getMarkets = async () => {
        markets().then(res => this.setState({ markets: res }));
    };

    handleSelectedMerchantByMarket = id => {
        const { selectedMarkets, listOfMerchantSelected } = this.state;

        const index = selectedMarkets.indexOf(id);

        if (index > -1) {
            selectedMarkets.splice(index, 1);
            this.setState({ listOfMerchantSelected: [] });
        } else {
            selectedMarkets.push(id);
        }

        this.setState({
            selectedMarkets,
            all: false,
            listOfMerchantSelectedUpdated: true
        });
    };

    render() {
        const {
            classes,
            isGenerating,
            anchorAlert,
            assuranceExpiree,
            assuranceManquante,
            bloque,
            bapRetard,
            siret,
            list,
            searchValue,
            page,
            numberOfPages,
            all,
            numberOfSelected,
            total,
            selectedMonths,
            years,
            weeksPerYear,
            frequency,
            listOfMerchantSelected,
            dateHasChanged,
            previewHasToUpdate,
            isSending,
            isDone,
            disableWeeksPerYear,
            markets,
            selectedMarkets
        } = this.state;

        return (
            <div className={classes.page}>
                <div className={classes.pageInner}>
                    {/* Breadcrumb now lives outside the card, as its own nav element */}
                    <div className={classes.breadcrumbRow}>
                        <IconButton
                            component={RouterLink}
                            to="/bills/subscribers/view"
                            size="small"
                            className={classes.backButton}>
                            <ArrowBackIcon fontSize="small" />
                        </IconButton>
                        <Breadcrumbs separator="/">
                            <Link
                                component={RouterLink}
                                to="/bills/subscribers/view"
                                className={classes.breadcrumbLink}
                                underline="none">
                                Facturation abonné
                            </Link>
                            <Typography className={classes.breadcrumbCurrent}>
                                Générer les factures des abonnés
                            </Typography>
                        </Breadcrumbs>
                    </div>

                    <div className={classes.pageHeader}>
                        <Typography variant="h4" className={classes.pageTitle}>
                            Générer les factures des abonnés
                        </Typography>
                        <Typography variant="body1" className={classes.pageSubtitle}>
                            Suivez les étapes pour sélectionner une période, les abonnés concernés,
                            puis générer et envoyer les factures.
                        </Typography>
                    </div>

                    <Paper className={classes.paper} elevation={1}>
                        <Alert
                            anchorAlert={anchorAlert}
                            data={{
                                assuranceExpiree: assuranceExpiree,
                                assuranceManquante: assuranceManquante,
                                bloque: bloque,
                                bapRetard: bapRetard
                            }}
                            siret={siret}
                            handleAlert={this.handleAlert}
                        />

                        <Stepper
                            className={classes.stepper}
                            connector={<ColorlibConnector />}
                            orientation="vertical">
                            <Step active expanded key={0}>
                                <StepLabel StepIconComponent={ColorlibStepIcon}>
                                    <FormLabel className={classes.stepTitle} component="label">
                                        Sélectionner une période
                                    </FormLabel>
                                </StepLabel>
                                <StepContent className={classes.stepContent}>
                                    <Periodicity
                                        handlePeriodicity={this.handlePeriodicity}
                                        frequency={frequency}
                                    />
                                </StepContent>
                            </Step>
                            <Step active expanded key={1}>
                                <StepLabel StepIconComponent={ColorlibStepIcon}>
                                    <FormLabel className={classes.stepTitle} component="label">
                                        Sélectionner une année et un/des mois
                                    </FormLabel>
                                </StepLabel>
                                <StepContent className={classes.stepContent}>
                                    <Grid container spacing={3} direction="column">
                                        <Grid item>
                                            <Year year={years} handleYear={this.handleYears} />
                                        </Grid>
                                        <Grid item>
                                            <Divider />
                                        </Grid>
                                        <Grid item>
                                            <Month
                                                handleSelectedMonths={this.handleSelectedMonths}
                                                frequency={frequency}
                                            />
                                        </Grid>
                                    </Grid>
                                </StepContent>
                            </Step>
                            {!disableWeeksPerYear && (
                                <Step active expanded key={2}>
                                    <StepLabel StepIconComponent={ColorlibStepIcon}>
                                        <FormLabel
                                            className={classes.stepTitle}
                                            style={{ color: '#DC2626' }}
                                            component="label">
                                            Saisir un nombre de semaines par période
                                        </FormLabel>
                                    </StepLabel>
                                    <StepContent className={classes.stepContent}>
                                        <TextField
                                            type="number"
                                            style={{ width: 200 }}
                                            variant="outlined"
                                            value={weeksPerYear}
                                            onChange={this.handleWeeks}
                                            InputProps={{
                                                inputProps: {
                                                    min: 0,
                                                    max: 52,
                                                    step: 1
                                                },
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <Typography
                                                            color="primary"
                                                            variant="button">
                                                            semaines
                                                        </Typography>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </StepContent>
                                </Step>
                            )}

                            <Step active expanded key={3}>
                                <StepLabel StepIconComponent={ColorlibStepIcon}>
                                    <FormLabel className={classes.stepTitle} component="label">
                                        Sélectionner des commerçants abonnés
                                    </FormLabel>
                                </StepLabel>
                                <StepContent className={classes.stepContent}>
                                    <Grid container direction="column" spacing={2}>
                                        <Grid item key={1}>
                                            <TextField
                                                label={'Rechercher un abonné'}
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                value={searchValue}
                                                onChange={this.handleSearch}
                                                helperText="Saisir une raison sociale, une enseigne, un nom, un prénom"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                onClick={this.clearSearch}
                                                                edge="end">
                                                                <ClearIcon
                                                                    style={{ color: '#DC2626' }}
                                                                />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </Grid>
                                        <Grid item key={2}>
                                            <Grid container spacing={1}>
                                                <Grid item>
                                                    <SelectionChip
                                                        label="Sélectionner tous les abonnés"
                                                        checked={all}
                                                        indeterminate={
                                                            numberOfSelected > 0 &&
                                                            numberOfSelected < total
                                                        }
                                                        disabled={selectedMarkets.length > 0}
                                                        onClick={() => this.handleAll(!all)}
                                                    />
                                                </Grid>
                                                {markets.map(market => (
                                                    <Grid item key={market.id}>
                                                        <SelectionChip
                                                            label={`${market.label} (${market.count_merchant})`}
                                                            checked={Boolean(
                                                                selectedMarkets.indexOf(market.id) >
                                                                    -1
                                                            )}
                                                            disabled={
                                                                all ||
                                                                (selectedMarkets.length > 0 &&
                                                                    Boolean(
                                                                        selectedMarkets.indexOf(
                                                                            market.id
                                                                        ) === -1
                                                                    ))
                                                            }
                                                            onClick={() =>
                                                                this.handleSelectedMerchantByMarket(
                                                                    market.id
                                                                )
                                                            }
                                                        />
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>
                                        <Grid item key={3}>
                                            <TableContainer className={classes.tableWrapper}>
                                                <Table
                                                    stickyHeader
                                                    size="small"
                                                    className={classes.table}>
                                                    <TableHead>
                                                        <TableRow>
                                                            {columns.map(column => (
                                                                <StyledTableCell
                                                                    key={column.id}
                                                                    align={column.align}
                                                                    style={{
                                                                        minWidth: column.minWidth
                                                                    }}>
                                                                    {column.label}
                                                                </StyledTableCell>
                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {list.map((merchant, index) => {
                                                            return (
                                                                <StyledTableRow
                                                                    hover
                                                                    key={merchant.id}>
                                                                    <TableCell align="left">
                                                                        <Grid
                                                                            container
                                                                            spacing={1}
                                                                            alignItems="center">
                                                                            <Grid item>
                                                                                <EnhancedCheckbox
                                                                                    key={`${merchant.id}_${merchant.selected}`}
                                                                                    handleListOfMerchant={() =>
                                                                                        this.handleListOfMerchant(
                                                                                            merchant.id,
                                                                                            selectedMarkets.length >
                                                                                                0 &&
                                                                                                merchant.selected ===
                                                                                                    '1'
                                                                                        )
                                                                                    }
                                                                                    noLoading={
                                                                                        selectedMarkets.length >
                                                                                            0 &&
                                                                                        merchant.selected ===
                                                                                            '1'
                                                                                    }
                                                                                    marchandId={
                                                                                        merchant.id
                                                                                    }
                                                                                    checked={Boolean(
                                                                                        merchant.selected ==
                                                                                            '1'
                                                                                    )}
                                                                                    disabled={
                                                                                        selectedMarkets.length >
                                                                                            0 &&
                                                                                        !listOfMerchantSelected.find(
                                                                                            v =>
                                                                                                v ===
                                                                                                merchant.id
                                                                                        )
                                                                                    }
                                                                                />
                                                                            </Grid>
                                                                            <Grid item>
                                                                                {this.alertMerchant(
                                                                                    merchant
                                                                                )}
                                                                            </Grid>
                                                                        </Grid>
                                                                    </TableCell>
                                                                    <TableCell align="left">
                                                                        {merchant.market}
                                                                    </TableCell>
                                                                </StyledTableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                        <Grid item>
                                            <Pagination
                                                numberOfPages={numberOfPages}
                                                currentPage={page}
                                                handlePagination={this.handlePagination}
                                            />
                                        </Grid>
                                    </Grid>
                                </StepContent>
                            </Step>
                            <Step active expanded key={4}>
                                <StepLabel StepIconComponent={ColorlibStepIcon}>
                                    <FormLabel className={classes.stepTitle} component="label">
                                        Pré-visualiser les factures avant leurs générations
                                    </FormLabel>
                                </StepLabel>
                                <StepContent className={classes.stepContent}>
                                    <Preview
                                        update={previewHasToUpdate}
                                        year={years}
                                        months={selectedMonths}
                                        weeksPerYear={weeksPerYear}
                                        merchants={listOfMerchantSelected}
                                        selectedMarkets={selectedMarkets}
                                    />
                                </StepContent>
                            </Step>
                            <Step active expanded key={5}>
                                <StepLabel StepIconComponent={ColorlibStepIcon}>
                                    <FormLabel className={classes.stepTitle} component="label">
                                        Généreration et envoi des factures
                                    </FormLabel>
                                </StepLabel>
                                <StepContent className={classes.stepContent}>
                                    <Grid
                                        container
                                        spacing={2}
                                        direction="column"
                                        alignItems="flex-start">
                                        <Grid item>
                                            <Grid
                                                container
                                                spacing={2}
                                                direction="row"
                                                justify="flex-start"
                                                alignItems="center">
                                                <Grid item>
                                                    <Button
                                                        disabled={isGenerating || isDone}
                                                        variant="contained"
                                                        color="primary"
                                                        disableElevation
                                                        className={classes.actionButton}
                                                        onClick={this.prepareBills}>
                                                        {isDone
                                                            ? 'Factures générées avec succés'
                                                            : 'Générer les factures'}
                                                    </Button>
                                                </Grid>
                                                {isGenerating && (
                                                    <Grid item>
                                                        <CircularProgress
                                                            color="primary"
                                                            size={25}
                                                        />
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                        <Grid item>
                                            <Grid
                                                container
                                                spacing={2}
                                                direction="row"
                                                justify="flex-start"
                                                alignItems="center">
                                                <Grid item>
                                                    <Grid container direction="row" spacing={2}>
                                                        <Grid item>
                                                            <Button
                                                                disabled={!isDone}
                                                                variant="contained"
                                                                color="primary"
                                                                disableElevation
                                                                className={classes.actionButton}
                                                                onClick={
                                                                    this.prepareBillsForSending
                                                                }>
                                                                Envoyer les factures
                                                            </Button>
                                                        </Grid>
                                                        <Grid item>
                                                            <Button
                                                                disabled={!isDone}
                                                                variant="contained"
                                                                color="primary"
                                                                disableElevation
                                                                className={classes.actionButton}
                                                                onClick={() =>
                                                                    this.prepareBillsForSending(
                                                                        true
                                                                    )
                                                                }>
                                                                Envoyer les factures et le rapport
                                                                d'assiduité
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                {isSending && (
                                                    <Grid item>
                                                        <CircularProgress
                                                            color="primary"
                                                            size={25}
                                                        />
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </StepContent>
                            </Step>
                        </Stepper>
                    </Paper>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(GenerateBills);
